import 'moment-timezone';

import * as localForage from 'localforage';

import { Injectable } from '@angular/core';
import { createStore } from '@ngneat/elf';
import { getAllEntities, getEntity, upsertEntities, withEntities } from '@ngneat/elf-entities';
import {
    clearRequestsCache, createRequestsCacheOperator, createRequestsStatusOperator,
    initializeAsPending, updateRequestCache, updateRequestStatus, withRequestsCache,
    withRequestsStatus
} from '@ngneat/elf-requests';
import { DefaultObject } from '@shared/interfaces';
import { persistState } from '@shared/third-party/persist-state/persist-state';

import { BaseRepository } from '../base.repository';
import { STORETIMEOUT } from '../db';

interface ProductTypes {
	product_type_id: number;
	product_type: string;
	product_key: string;
}

const store = createStore(
	{ name: 'productTypes' },
	withEntities<ProductTypes, 'product_type_id'>({ idKey: 'product_type_id' }),
	withRequestsStatus<`productTypes`>(initializeAsPending('productTypes')),
	withRequestsCache<`productTypes`>()
);
export const trackProductTypesRequestsStatus = createRequestsStatusOperator(store);
export const persist = persistState(store, {
	key: 'productTypes',
	storage: localForage,
});
export const skipWhileProductTypesCached = createRequestsCacheOperator(store);
setInterval(() => store.update(clearRequestsCache()), STORETIMEOUT);

@Injectable({ providedIn: 'root' })
export class ProductTypesRepository extends BaseRepository {
	/*
	 **-------------------------------------------------------------------------------------
	 ** METHOD NAME - constructor
	 **-------------------------------------------------------------------------------------
	 */
	constructor() {
		super();
	}
	/*
	 **-------------------------------------------------------------------------------------
	 ** METHOD NAME - store
	 **-------------------------------------------------------------------------------------
	 */
	get store() {
		return store;
	}
	/*
	 **-------------------------------------------------------------------------------------
	 ** METHOD NAME - queries
	 **-------------------------------------------------------------------------------------
	 */
	getAll = () => store.query(getAllEntities());
	get = id => store.query(getEntity(id));

	/*
	 **-------------------------------------------------------------------------------------
	 ** METHOD NAME - add
	 **-------------------------------------------------------------------------------------
	 */
	public add(items) {
		store.update(
			upsertEntities(items),
			updateRequestCache('productTypes', { ttl: STORETIMEOUT }),
			updateRequestStatus('productTypes', 'success')
		);
	}
}
